function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'green-wengen': 'rgb(1, 118, 109)','grey-zinal': 'rgb(73, 70, 75)','grey-zinal': 'rgb(73, 70, 75)','blue-st-moritz': 'rgb(69, 70, 101)','red-verbier': 'rgb(220, 48, 62)','pink-montana': 'rgb(219, 69, 117)','grey-saas-fee': 'rgb(159, 159, 159)','black-laax': 'rgb(17, 17, 17)','pink-flims': 'rgb(246, 207, 208)','rosa-flims': 'rgb(246, 207, 208)','blue-zermatt': 'rgb(60, 88, 153)','green-gstaad': 'rgb(118, 147, 60)','camel-arolla': 'rgb(230, 184, 183)','cream-andermatt': 'rgb(221, 217, 196)','navy': 'rgb(19, 34, 87)','turquoise-adelboden': 'rgb(0, 176, 240)','green-engelberg': 'rgb(163, 225, 221)','blue-aletsch': 'rgb(190, 207, 244)','polar-white': '','rosa-montana': 'rgb(219, 69, 117)','orange-arosa': 'rgb(254, 115, 20)',};

    this.images = {'rouge-et-noir': 'url("//fjorkmerino.com/cdn/shop/files/Rougeetnoir_68x.png?v=17842768480652380262")','brb': 'url("//fjorkmerino.com/cdn/shop/files/Rougeetnoir_68x.png?v=17842768480652380262")','turquoise-gris': 'url("//fjorkmerino.com/cdn/shop/files/turquoisegris_68x.png?v=11937763908878628595")','grey-black': 'url("//fjorkmerino.com/cdn/shop/files/Greyblack_68x.png?v=7719648637792941516")','gris-noir': 'url("//fjorkmerino.com/cdn/shop/files/Greyblack_68x.png?v=7719648637792941516")','schwarzes-laax': 'url("//fjorkmerino.com/cdn/shop/files/schwarz_68x.png?v=7260782577005823746")','grau-saas-fee': 'url("//fjorkmerino.com/cdn/shop/files/grau_68x.png?v=8864497597381487387")','kaki-black': 'url("//fjorkmerino.com/cdn/shop/files/kakiblack_68x.png?v=6366520245116945012")','black-red-logo': 'url("//fjorkmerino.com/cdn/shop/files/cap2_68x.png?v=2902036513555680486")','white-grey-logo': 'url("//fjorkmerino.com/cdn/shop/files/whitegreylogo_68x.png?v=7118314774267988522")','black-white-logo': 'url("//fjorkmerino.com/cdn/shop/files/cap1_68x.png?v=9995004149329600819")','kaki-black-logo': 'url("//fjorkmerino.com/cdn/shop/files/cap4_68x.png?v=17514852497767867432")','pink-white-logo': 'url("//fjorkmerino.com/cdn/shop/files/cap5_68x.png?v=13502839093500893936")','grey-turquoise-logo': 'url("//fjorkmerino.com/cdn/shop/files/cap3_68x.png?v=5051887166063584341")','red-white-logo': 'url("//fjorkmerino.com/cdn/shop/files/cap7_68x.png?v=15650067134435474080")','navy-white-logo': 'url("//fjorkmerino.com/cdn/shop/files/cap6_68x.png?v=14378732068966926769")','red-blue': 'url("//fjorkmerino.com/cdn/shop/files/redblue_68x.png?v=14283670454175212796")','green-blue': 'url("//fjorkmerino.com/cdn/shop/files/greenblue_68x.png?v=2391677251701372484")','bwb': 'url("//fjorkmerino.com/cdn/shop/files/BWB_68x.png?v=4777901695805613876")',};

    this.triggers = ['color','couleur','farbe',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
